// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2IJWB","buttons":"PendingPaymentAlert_buttons__3HmEd"};